function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icn_cons-complete-BLACK",
  fill: "#ffffff",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.7,12 L19.7,12 C20,12.3 20,12.8 19.8,13.1 L12.6,21.5 C12.2,21.9 11.6,22 11.2,21.6 L11.2,21.6 L11.2,21.6 L8.4,18.9 C8.1,18.6 8.1,18.1 8.4,17.8 C8.7,17.5 9.2,17.5 9.5,17.8 L12,20.2 L18.9,12.1 C19,11.8 19.4,11.8 19.7,12 Z M11.6,0 C11.8,0 12,0.1 12.1,0.2 L15.8,4 C16,4.1 16,4.3 16,4.5 L16,11.8 C16,12.2 15.7,12.5 15.3,12.5 C14.9,12.5 14.6,12.2 14.6,11.8 L14.6,5.4 L11,5.4 C10.4,5.4 10,5 10,4.4 L10,1.4 L1.7,1.4 C1.5,1.4 1.4,1.5 1.4,1.7 L1.4,18.3 C1.4,18.4 1.5,18.6 1.7,18.6 L5.5,18.6 C5.9,18.6 6.2,18.9 6.2,19.3 C6.2,19.7 5.9,20 5.5,20 L1.7,20 C0.8,20 0,19.2 0,18.3 L0,1.7 C0,0.8 0.8,0 1.7,0 L11.6,0 Z M7.8,14 C8.2,14 8.6,14.3 8.6,14.8 C8.6,15.2 8.3,15.5 7.8,15.5 L3.8,15.5 C3.4,15.5 3,15.2 3,14.8 C3,14.3 3.3,14 3.8,14 L7.8,14 Z M12.2,11 C12.6,11 13.1,11.3 13.1,11.8 C13.1,12.3 12.7,12.6 12.2,12.6 L3.8,12.6 C3.4,12.6 3,12.3 3,11.8 C3,11.3 3.3,11 3.8,11 L12.2,11 Z M12.3,8 C12.7,8 13,8.3 13,8.7 C13,9.1 12.7,9.5 12.2,9.5 L3.8,9.5 C3.3,9.5 3,9.2 3,8.7 C3,8.2 3.3,8 3.8,8 L12.3,8 Z M11.4,1.6 L11.4,4 L13.8,4 L11.4,1.6 Z",
  id: "Combined-Shape"
})));
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.21198914.svg";
export { ForwardRef as ReactComponent };